export default __webpack_public_path__ + "static/media/ic-ada-bep20.1b00ef37.svg";